import { gql } from '@apollo/client';

export const LOG_MUTATION = gql`
  mutation LogMutation($input: LogEntry!) {
    log(input: $input)
  }
`;
